<template>
  <SectionTemplate
    title="从“能说”到“会演” AI赋予数字人生动表现力"
    subTitle="自然生动的数字人表现力"
    theme="dark"
    :desc="`只需输入一段文字，AI 即可生成声音、表情和动作，\n让 3D 数字人像你一样声情并茂地传递信息，轻松应对培训、演讲、营销等多种视频场景`"
  >
    <div class="card-list">
      <FeatureCard
        v-for="(feature, index) in featureList"
        :key="index"
        v-bind="feature"
        btnText="免费试用"
      />
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import FeatureCard from '@/design/components/feature-card/index.vue';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';

const featureList = [
  {
    title: `AI生成语音
数字人一开口，就能打动人`,
    description:
      '由TTS语音合成技术驱动，AI深度理解文本语义，自动生成自然流畅的语音语调，彻底告别机械合成感。无论是主播带货的感染力，还是专业主持的沉稳表达，都能精准呈现，一秒入戏。',
    video: getFeUrl('/youyan-platform/character-intro/ai-feature/tone.webm'),
    image: getFeUrl(
      '/youyan-platform/character-intro/ai-feature/tone.png?x-oss-process=image/format,webp',
    ),
    muted: false,
    theme: 'dark' as const,
  },
  {
    title: `不再"站桩"讲解
AI生成自然流畅的动作与表情`,
    description:
      '借助有言自研的文生动作大模型，AI可深度理解文本内容，自动生成与语义高度契合的肢体动作与面部表情。无需真人拍摄或动作捕捉，站立播报、走动讲解、坐姿交流都能生动演绎，让视频表达更具感染力。',
    video: getFeUrl('/youyan-platform/character-intro/ai-feature/2.webm'),
    image: getFeUrl(
      '/youyan-platform/character-intro/ai-feature/2.png?x-oss-process=image/format,webp',
    ),
    reverse: true,
    theme: 'dark' as const,
  },
  {
    title: `AI还原真实情绪
让表达更有温度`,
    description:
      'AI根据文本内容，自动生成高度匹配的情绪与表情，开心、困惑、严肃...每个表情都恰到好处。配合语音语调和肢体动作，整体表达更生动真实，内容自然更有吸引力。',
    video: getFeUrl('/youyan-platform/character-intro/ai-feature/3.webm'),
    image: getFeUrl(
      '/youyan-platform/character-intro/ai-feature/3.png?x-oss-process=image/format,webp',
    ),
    theme: 'dark' as const,
  },
];
</script>

<style lang="scss" scoped src="./pc.scss" />
<style lang="scss" scoped src="./mobile.scss" />
